'use client';

import { useSyncExternalStore } from 'react';

let awaitingAdobeModalSignIn = false;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((listener) => {
    listener();
  });
}

export function setJarvisSupportLauncherAwaitingAdobeModalSignIn(
  next: boolean
): void {
  if (awaitingAdobeModalSignIn === next) return;
  awaitingAdobeModalSignIn = next;
  emit();
}

function subscribe(onStoreChange: () => void) {
  listeners.add(onStoreChange);
  return () => {
    listeners.delete(onStoreChange);
  };
}

function getSnapshot() {
  return awaitingAdobeModalSignIn;
}

export function useJarvisSupportLauncherAwaitingAdobeModalSignIn(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
